
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { PartnerCreateDto, PartnerDto } from '../api/Manipulate/Partners';
@Injectable({
  providedIn: 'root'
})
export class PartnerService {
  private apiUrl = environment.apiUrl + '/partner';

  constructor(private http: HttpClient) { }


  public List() : Observable<PartnerDto[]>{
    return this.http.get<PartnerDto[]>(`${this.apiUrl}`);
  }
  public ListUnactive() : Observable<PartnerDto[]>{
    return this.http.get<PartnerDto[]>(`${this.apiUrl}/unactive`);
  }
  public Add(dtoCreate : PartnerCreateDto) : Observable<any>{
    return this.http.post(`${this.apiUrl}`, dtoCreate);
  }
  public Edit(dto: PartnerDto): Observable<any> {
    return this.http.put(`${this.apiUrl}/${dto.id}`, dto);
  }
  public Delete(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
  public Reactive(id: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/reactive/${id}`, '');
  }
  public GetHash(input : PartnerDto) : Observable<any>{
    return this.http.post(`${this.apiUrl}/get-hash`, input, { responseType: 'text' });
  }

}
